module.exports = __webpack_public_path__ + "media/application/images/decision-maker-bg-6290624eb16a937fba186259aed37e71.png";